<template>
  <div class="home-container">
    <div class="home-container-header">
      <TheHeader ref="header" />
    </div>
    <div ref="boardContainer" class="home-container-board" v-if="activeBoard">
      <Board :board="activeBoard" />
    </div>
    <div ref="boardContainer" class="home-container-board" v-else>
      <p class="pl-2">{{ loaded ? "Создайте свою первую доску, нажав плюс на тулбаре" : "Грузим..." }}</p>
    </div>
    <div class="home-container-history" v-if="showHistory">
      <History />
    </div>
    <div class="home-container-messages" v-if="showMessages">
      <Messages />
    </div>

    <NewBoard />
    <EditCardModal />
    <EditBoardModal />
    <EditListModal />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import AutoScrollBehaviour from "@/common/autoScrollBehaviour";

import TheHeader from "@/components/header/TheHeader.vue";
import Board from "@/components/board/Board.vue";

import NewBoard from "@/dialogs/NewBoard.vue";
import EditCardModal from "@/dialogs/EditCardModal.vue";
import EditBoardModal from "@/dialogs/EditBoardModal.vue";
import EditListModal from "@/dialogs/EditListModal.vue";

import History from "@/components/History.vue";
import Messages from "@/components/Messages.vue";

import cache from "@/store/cache.js";

export default {
  name: "home",
  components: {
    TheHeader,
    NewBoard,
    Board,
    EditCardModal,
    EditBoardModal,
    EditListModal,
    History,
    Messages
  },
  data() {
    return {
      autoScrollBehaviour: new AutoScrollBehaviour()
    };
  },
  computed: {
    ...mapGetters(["windowHeight", "loaded"]),
    ...mapState(["drag"]),
    ...mapState("users", { activeUser: "active" }),
    ...mapState("boards", { activeBoard: "active", allBoards: "all" }),
    ...mapState(["window", "showHistory", "showArchive", "showMessages"])
  },
  methods: {
    onkey(event) {
      if (!event || !event.altKey || !event.code) return;
      if (event.code.indexOf("Digit") != 0) return;

      const numberStr = event.code.substring(5, event.code.length);
      const number = parseInt(numberStr);

      const board = this.allBoards[number - 1];
      if (!board) return;

      this.$store.dispatch("boards/activateBoard", board);
    }
  },
  mounted() {
    this.autoScrollBehaviour.unsubsribe();
    this.autoScrollBehaviour.canScroll = () => this.drag.card; // || this.drag.list;
    this.autoScrollBehaviour.subsribe(this.$refs.boardContainer);

    const routerParams = this.$router.currentRoute.params;
    if (routerParams.inBoardId) {
      this.$modal.show("EditCardModal", {
        boardId: routerParams.boardId,
        inBoardId: routerParams.inBoardId
      });
    } else if (routerParams.cardId) {
      this.$modal.show("EditCardModal", {
        boardId: routerParams.boardId,
        cardId: routerParams.cardId
      });
    } else if (routerParams.listId) {
      this.$modal.show("EditListModal", {
        listId: routerParams.listId
      });
    } else if (routerParams.boardAction == "edit" && routerParams.boardId) {
      this.$modal.show("EditBoardModal", {
        boardId: routerParams.boardId
      });
    }

    //get initial data
    this.$nextTick(() => {
      //litte hack, to be sure that everything is updated beforeload a lot of data
      const payload = { user_id: this.activeUser.id };
      if (routerParams.boardId) {
        payload.board_id = routerParams.boardId;
      }
      if (routerParams.inBoardId) {
        payload.in_board_id = routerParams.inBoardId;
      }
      if (routerParams.cardId) {
        payload.card_id = routerParams.cardId;
      }
      console.log("get_init", { payload, routerParams });
      this.$socket.emit("get_init", payload);
    });
  },
  created() {
    window.addEventListener("keydown", this.onkey.bind(this));
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onkey);
    this.autoScrollBehaviour.unsubsribe();
  },
  watch: {
    "$route.params.boardId": {
      handler: function (boardId) {
        if (!boardId) {
          return;
        }

        this.$store.dispatch("boards/activateBoard", parseInt(boardId));
      },
      immediate: true
    },
    "$route.params.boardAction": {
      handler: function (boardAction) {
        const boardId = parseInt(this.$route.params.boardId);
        if (boardAction != "edit" || !boardId) {
          this.$modal.hide("EditBoardModal");
          return;
        }

        this.$modal.show("EditBoardModal", {
          board: cache.boards.byId(boardId),
          boardId: boardId
        });
      },
      immediate: true
    },
    "$route.params.listId": {
      handler: function (listId) {
        if (!listId) {
          this.$modal.hide("EditListModal");
          return;
        }
        listId = parseInt(listId);
        this.$modal.show("EditListModal", {
          list: cache.lists.byId(listId),
          listId: listId
        });
      },
      immediate: true
    },
    "$route.params.cardId": {
      handler: function (cardId) {
        if (!cardId) {
          this.$modal.hide("EditCardModal");
          return;
        }
        cardId = parseInt(cardId);
        this.$modal.show("EditCardModal", {
          card: cache.cards.byId(cardId),
          cardId: cardId
        });
      },
      immediate: true
    },
    "$route.params.inBoardId": {
      handler: function (inBoardId) {
        if (!inBoardId) {
          this.$modal.hide("EditCardModal");
          return;
        }
        inBoardId = parseInt(inBoardId);
        const boardId = parseInt(this.$route.params.boardId);

        this.$modal.show("EditCardModal", {
          card: cache.cards.byInBoardId(boardId, inBoardId),
          boardId: boardId,
          inBoardId: inBoardId
        });
      },
      immediate: true
    }
  }
};
</script>

<style lang="postcss">
.home-container {
  display: grid;
  grid-template-areas:
    "header header"
    "board history";
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 1fr;
  height: 100vh;

  &-header {
    grid-area: header;
  }

  &-board {
    grid-area: board;
    overflow-x: auto;
    overflow-y: hidden;
  }

  &-history {
    grid-area: history;
  }
  &-messages {
    grid-area: history;
  }
}
</style>
